import { combineReducers } from "redux";
import btaxReducer from "./btaxReducer";
import authReducer from "./authReducer";

export default combineReducers({
  btaxReducer: btaxReducer,
  authReducer: authReducer
});
